import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useContext } from 'react'; // import { Icon } from '../index'

import classnames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import { tuple } from '../_utils/type';
import { isArrayValueRepeat } from '../_utils/arrayUtil';
import isArray from 'lodash/isArray';
import Checkbox from './checkbox';
import isBoolean from 'lodash/isBoolean';
import devWarning from '../_utils/devwarning';
export var CheckboxTypes = tuple('default', 'square');
export var CheckboxSizes = tuple('large', 'middle', 'small');
var CheckboxGroup = /*#__PURE__*/React.forwardRef(function (props, ref) {
  // const CheckboxGroup = (props: CheckboxGroupProps): FunctionComponentElement<CheckboxGroupProps> => {
  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps;

  var CheckboxProps = getCompProps('Checkbox', userDefaultProps, props); // 按钮属性需要合并一遍用户定义的默认属性

  var checkboxType = CheckboxProps.checkboxType,
      className = CheckboxProps.className,
      style = CheckboxProps.style,
      customPrefixcls = CheckboxProps.prefixCls,
      options = CheckboxProps.options,
      size = CheckboxProps.size,
      onChange = CheckboxProps.onChange,
      disabled = CheckboxProps.disabled,
      children = CheckboxProps.children,
      defaultValue = CheckboxProps.defaultValue,
      value = CheckboxProps.value,
      name = CheckboxProps.name;

  var _React$useState = React.useState(defaultValue),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      groupValue = _React$useState2[0],
      setGroupValue = _React$useState2[1];

  React.useEffect(function () {
    if (value) {
      setGroupValue(value);
    }
  }, [value]);
  var checkboxGroupPrefixCls = getPrefixCls(prefixCls, 'checkbox-group', customPrefixcls); // 按钮样式前缀

  devWarning(isArrayValueRepeat(value), 'checkboxGroup', "variable value's value should be unique ");

  var getDisabled = function getDisabled(optionDisabled) {
    return isBoolean(optionDisabled) ? optionDisabled : disabled;
  };

  var getChecked = function getChecked(props, value) {
    return isArray(value) ? _includesInstanceProperty(value).call(value, (props === null || props === void 0 ? void 0 : props.value) || props) || _includesInstanceProperty(value).call(value, String((props === null || props === void 0 ? void 0 : props.value) || props)) : String(value) === String((props === null || props === void 0 ? void 0 : props.value) || props);
  };

  var getReduceItem = function getReduceItem(targetValue) {
    var index = value.indexOf(targetValue);

    _spliceInstanceProperty(value).call(value, index, 1);

    return value;
  };

  var getAddItem = function getAddItem(targetValue) {
    return _concatInstanceProperty(value).call(value, targetValue);
  };

  var onCheckboxChange = function onCheckboxChange(ev, item) {
    var _a;

    var val = ev.target.value;
    var checked = ev.target.checked;
    var newVal = [];

    if (checked) {
      newVal = getAddItem(val);
    } else {
      newVal = getReduceItem(val);
    }

    setGroupValue(newVal);
    onChange && onChange(newVal);
    ((_a = item.props) === null || _a === void 0 ? void 0 : _a.onChange) && item.props.onChange(ev);
  };

  var renderByOptions = function renderByOptions() {
    return _mapInstanceProperty(options).call(options, function (option, index) {
      return /*#__PURE__*/React.createElement(Checkbox, {
        size: size,
        disabled: getDisabled(option.disabled),
        key: index,
        name: name,
        defaultChecked: getChecked(option, defaultValue),
        checked: getChecked(option, groupValue),
        checkboxType: checkboxType,
        value: (option === null || option === void 0 ? void 0 : option.value) || option,
        onChange: function onChange(e) {
          return onCheckboxChange(e, option);
        }
      }, option.label || option);
    });
  };

  var renderChildren = function renderChildren() {
    var _context;

    return _mapInstanceProperty(_context = React.Children).call(_context, children, function (item) {
      var _a, _b;

      var groupProps = {};
      groupProps = {
        name: name,
        size: size,
        onChange: function onChange(e) {
          return onCheckboxChange(e, item);
        },
        checkboxType: checkboxType || ((_a = item.props) === null || _a === void 0 ? void 0 : _a.checkboxType),
        disabled: isBoolean(disabled) ? disabled : (_b = item.props) === null || _b === void 0 ? void 0 : _b.disabled,
        checked: getChecked(item.props, groupValue),
        defaultChecked: getChecked(item.props, defaultValue)
      };
      return /*#__PURE__*/React.cloneElement(item, _extends(_extends({}, item.props), groupProps));
    });
  };

  var renderCheckbox = function renderCheckbox() {
    if (isArray(options)) {
      return renderByOptions();
    } else if (children) {
      return renderChildren();
    }
  };

  return /*#__PURE__*/React.createElement("ul", {
    className: classnames(checkboxGroupPrefixCls, className),
    style: style,
    ref: ref
  }, renderCheckbox());
});
export default /*#__PURE__*/React.memo(CheckboxGroup);